var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"field",attrs:{"label":_vm.label,"value":_vm.value,"append-outer-icon":"fas fa-copy","readonly":""},on:{"click:append-outer":function($event){$event.stopPropagation();return _vm.copy($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }